import React, { Component } from "react";
import { Select, Button, message, Table, Modal } from "antd";
import { search, download, billDetails, getCombGames } from "@api/channelBill";
import { getAllGames } from "@api/statistics";
import { formatDate } from "@utils/tool";
import bus from "@utils/bus";
import { store } from "../store-manager";
import { getChannelByLvl } from "@api/user";

const Option = Select.Option;
const downloadjs = require("downloadjs");
class ChannelBill extends Component {
  state = {
    userInfo: bus.userInfo,
    roles: bus._roles,
    visible: false,
    selectedVal: {
      start: 0,
      end: 0,
    },
    allSelect: [
      {
        key: "year",
        placeholder: "请选年份",
        options: [],
        title: "选择年份",
      },
    ],
    channelSelectedVal: {
      firstLevel: "",
      secondLevel: "allSecondLevel",
      // thirdChannels: ["allThirdLevel"]
      thirdChannels: "allThirdLevel",
    },
    channelSelect: [
      {
        key: "firstLevel",
        placeholder: "请选一级渠道",
        options: [],
      },
      {
        key: "secondLevel",
        defaultValue: "allSecondLevel",
        options: [{ value: "allSecondLevel", label: "全部二级渠道" }],
      },
      {
        key: "thirdChannels",
        // defaultValue: ['allThirdLevel'],
        defaultValue: "allThirdLevel",
        // mode: 'multiple',
        options: [{ value: "allThirdLevel", label: "全部三级渠道" }],
      },
    ],
    allChannel: [],
    jsonChannel: {},
    jsonSubChannel: {},
    tableData: [],
    currtenMonth: "",
    currentTime: {},
    pagination: {
      pageSzie: 10,
      current: 1,
      total: 0,
    },
    jsonAllGames: {},
    allGamesType: {},
    defaultColumns: [],

    fixColumns: [
      {
        title: "日期",
        dataIndex: "time",
        align: "center",
        width: "150px",
      },
      {
        title: "一级渠道",
        dataIndex: "channel",
        align: "center",
        width: "150px",
      },
      {
        title: "二级渠道",
        dataIndex: "subChannel",
        align: "center",
        width: "150px",
      },
      {
        title: "三级渠道",
        dataIndex: "thirdChannel",
        align: "center",
        width: "150px",
      },
      {
        title: "游戏",
        dataIndex: "gameId",
        key: "gameId",
        align: "center",
        width: "150px",
        render: (text) => (
          <span>{this.state.jsonAllGames[text] + "（" + text + "）"}</span>
        ),
      },
      {
        title: "游戏类型",
        dataIndex: "gameId",
        key: "gameTp",
        align: "center",
        width: "150px",
        render: (gameId) => (
          <span>{this.gameTypeMap[this.state.allGamesType[gameId]]}</span>
        ),
      },
      {
        title: "首次创角用户数",
        dataIndex: "channelFirstPlayerRoles",
        align: "center",
        width: "150px",
        render: (text, record) => (
          <span>{Number(record.channelFirstPlayerRoles).toFixed(2)}</span>
        ),
      },
    ],
    detailHideColumns: [],
    origColumns: [
      {
        title: "新增",
        dataIndex: "newUser",
        align: "center",
        width: "100px",
        render: (text, record) => {
          return <span>{Number(record.newUser).toFixed(2)}</span>;
        },
      },

      {
        title: "总收益",
        dataIndex: "income",
        align: "center",
        width: "100px",
        render: (text, record) => {
          return <span>{Number(record.income).toFixed(2)}</span>;
        },
      },
      // {
      //     title: "总分成",
      //     dataIndex: "rltIncome",
      //     align: "center",
      //     width: "100px",
      //     render: (text, record) => (
      //         <span>{Number(record.rltIncome).toFixed(2)}</span>
      //     )
      // },
      {
        title: "总退款",
        dataIndex: "refundMoney",
        align: "center",
        width: "100px",
        render: (text, record) => {
          return <span>{Number(record.refundMoney).toFixed(2)}</span>;
        },
      },
    ],
  };

  //游戏类型枚举
  gameTypeMap = {
    minigame: "微信小游戏",
    miniprogram: "微信小程序",
    app: "APP",
    "qq-minigame": "QQ小游戏",
    "douyin-minigame": "抖音小游戏",
    "qq-miniprogram": "QQ小程序",
    comb: "融合游戏",
  };
  getAllYears = () => {
    // ??? 离谱的时间区间
    const currentYear = new Date().getFullYear();
    let tempAllSelect = this.state.allSelect;
    tempAllSelect[0].options = [];

    for (let i = 2018; i <= currentYear; i++) {
      tempAllSelect[0].options.push({ value: i, label: i });
    }

    this.setState({ allSelect: tempAllSelect });
  };

  handleSearch = () => {
    this.searchData(this.state.selectedVal);
  };

  handleDownload = () => {
    if (this.state.channelSelectedVal.firstLevel === "") {
      message.error("请选一级二级渠道为必选");
      return;
    }

    const { thirdChannels } = this.state.channelSelectedVal;
    // const tempThirdChannels = thirdChannels.includes('allThirdLevel') ? [] : thirdChannels;
    const tempThirdChannels =
      thirdChannels === "allThirdLevel" ? [] : [thirdChannels];

    let params = {
      ...this.state.currentTime,
      channel: this.state.channelSelectedVal.firstLevel,
      subChannel:
        this.state.channelSelectedVal.secondLevel === "allSecondLevel"
          ? Object.keys(this.state.jsonSubChannel)
          : [this.state.channelSelectedVal.secondLevel],
      thirdChannels: tempThirdChannels,
      page: 1,
      size: this.state.pagination.total,
    };
    download(params).then((res) => {
      downloadjs(res.data);
    });
  };

  searchData = (data) => {
    search(data).then((res) => {
      if (res.data.meta.errCode !== 0) {
        message.error(res.data.meta.errMsg);
        return;
      }
      this.setState({ tableData: res.data.data.list || [] });
    });
  };

  changePage = (page) => {
    const tempPagination = {
      total: page.total,
      current: page.current,
      pageSzie: 10,
    };

    this.setState({ pagination: tempPagination }, () => {
      this.searchChannelData();
    });
  };

  handleChannelBreakdown = (data) => {
    this.setState({
      currentTime: this.getMonthTime(data.timestamp),
      currtenMonth: this.getCurrentTimeFormat(data.timestamp),
      visible: true,
    });
  };

  handleChannelSearch = () => {
    if (this.state.channelSelectedVal.firstLevel === "") {
      message.error("请选一级二级渠道为必选");
      return;
    }

    // 点击查询按钮, 重置分页信息
    const tempPagination = {
      pageSzie: 10,
      current: 1,
      total: 0,
    };
    this.setState({ pagination: tempPagination }, () => {
      this.searchChannelData();
    });
  };

  searchChannelData = () => {
    const { thirdChannels } = this.state.channelSelectedVal;
    const time = this.state.currentTime;
    // const tempThirdChannels = thirdChannels.includes('allThirdLevel') ? [] : thirdChannels;
    const tempThirdChannels =
      thirdChannels === "allThirdLevel" ? [] : [thirdChannels];

    let params = {
      ...time,
      channel: this.state.channelSelectedVal.firstLevel,
      subChannel:
        this.state.channelSelectedVal.secondLevel === "allSecondLevel"
          ? Object.keys(this.state.jsonSubChannel)
          : [this.state.channelSelectedVal.secondLevel],
      thirdChannels: tempThirdChannels,
      page: this.state.pagination.current,
      size: 10,
    };

    billDetails(params).then((res) => {
      if (res.code === 200 && res.data.meta.errCode !== 0) {
        message.error(res.data.meta.errMsg);
        return;
      }

      const list = res.data.data.list || [];
      const detailHideColumns = res.data.data.hide || [];
      const paging = res.data.meta.paging || {};
      this.setState({
        detailHideColumns,
      });
      this.handleChannelData(list, paging);
    });
  };

  handleChannelData = (list, paging) => {
    const tempPagination = {
      total: paging.total,
      current: paging.page,
      pageSzie: 10,
    };
    let tempList = [];
    const { channelSelectedVal, thirdList } = this.state;
    const { thirdChannels } = channelSelectedVal;
    const temp = (thirdList || []).find((i) => thirdChannels === i.id);
    const thirdChannel =
      thirdChannels === "allThirdLevel" ? "全部" : temp.name || "全部";

    tempList = list.map((item, index) => {
      const channel = this.state.jsonChannel[
        this.state.channelSelectedVal.firstLevel
      ];
      const subChannel =
        this.state.channelSelectedVal.secondLevel === "allSecondLevel"
          ? "全部"
          : this.state.jsonSubChannel[
              this.state.channelSelectedVal.secondLevel
            ];

      Object.assign(item, {
        index: index,
        channel: channel,
        subChannel: subChannel,
        thirdChannel,
      });

      return item;
    });
    let defaultColumns = [];
    if (tempList.length) {
      // 过滤掉gameId为ctwz的数据
      tempList = tempList.filter((item) => {
        return item.gameId !== "ctwz";
      });
      const tempKeys = Object.keys(tempList[0]);
      const filterColumns = this.state.origColumns.filter((item) => {
        return tempKeys.indexOf(item.dataIndex) > -1;
      });
      defaultColumns = this.state.fixColumns.concat(filterColumns);
    } else {
      defaultColumns = [];
    }

    this.setState({
      pagination: tempPagination,
      tableDetailData: tempList,
      defaultColumns,
    });
  };

  getMonthTime = (data) => {
    if (!data) return;

    let month = new Date(data * 1000).getMonth();
    let year = new Date(data * 1000).getFullYear();

    return {
      start: new Date(year, month, 1, 0, 0, 0).getTime() / 1000,
      end: new Date(year, month + 1, 1, 0, 0, 0).getTime() / 1000,
    };
  };

  getCurrentTimeFormat = (time) => {
    return formatDate(time * 1000, "yyyy-MM");
  };

  getFirstChannel = async () => {
    const ret = await getChannelByLvl(1);
    if (ret && ret.data && ret.data.data) {
      const resp = ret.data.data || [];
      store.sync({
        firstChannel: resp,
      });
      console.log("all first channel: ", resp);
    }
  };

  getSecondChanelById = async (parentId) => {
    const ret = await getChannelByLvl(2, parentId);
    if (ret && ret.data && ret.data.data) {
      const resp = ret.data.data || [];
      console.log("all second channel: ", resp);
      store.sync({
        secondChannel: resp,
      });
    }
  };

  getThirdChannelById = async (parentId) => {
    const ret = await getChannelByLvl(3, parentId);
    if (ret && ret.data && ret.data.data) {
      const resp = ret.data.data || [];
      console.log("all third channel: ", resp);
      store.sync({
        thirdChannel: resp,
      });
    }
  };

  getAllChannel = async () => {
    if (true) {
      await this.getFirstChannel();
      const res = store.remote.firstChannel;
      const data = res || [];
      const initOpt = [];
      let tempChannel = {};

      data.forEach((item) => {
        tempChannel[item.id] = item.name;
      });

      this.setState({ allChannel: data, jsonChannel: tempChannel });
      this.setFormData(this.state.channelSelect, "firstLevel", data, initOpt);
    } else {
      store.hasAllChannel().then(() => {
        console.log(store.remote);
        const res = store.remote.channel;

        const data = res || [];
        const initOpt = [];
        let tempChannel = {};

        data.forEach((item) => {
          tempChannel[item.id] = item.name;
        });

        this.setState({ allChannel: data, jsonChannel: tempChannel });
        this.setFormData(this.state.channelSelect, "firstLevel", data, initOpt);
      });
    }
  };

  handleChannelSelectChange = (val, key) => {
    console.log(val, key);
    const tempChannelSelect = this.state.channelSelect;
    const tempChannelSelectedVal = this.state.channelSelectedVal;
    tempChannelSelectedVal[key] = val;

    if (key === "firstLevel") {
      tempChannelSelect[0].defaultValue = val;
      tempChannelSelect[1].defaultValue = "allSecondLevel";
      // tempChannelSelect[2].defaultValue = ["allThirdLevel"];
      tempChannelSelect[2].defaultValue = "allThirdLevel";
      // 处理一级, 二级渠道联动
      this.handleChannelLinkage(val);
    }
    if (key === "secondLevel") {
      tempChannelSelect[1].defaultValue = val;
      // tempChannelSelect[2].defaultValue = ["allThirdLevel"];
      tempChannelSelect[2].defaultValue = "allThirdLevel";
      // 处理二级, 三级渠道联动
      this.handleSecondChannelToThirdChannel(val);
    }
    if (key === "thirdChannels") {
      tempChannelSelect[2].defaultValue = val;
    }
    this.setState({ channelSelect: tempChannelSelect });
  };

  async handleSecondChannelToThirdChannel(val) {
    if (true) {
      await this.getThirdChannelById(val);
      const thirdList = store.remote.thirdChannel;
      const channelSelect = this.state.channelSelect;
      const temp = thirdList.map((i) => ({ value: i.id, label: i.name })) || [];
      channelSelect[2].options = [
        { value: "allThirdLevel", label: "全部三级渠道" },
        ...temp,
      ];
      this.setState({ channelSelect, thirdList });
    } else {
      const { secondList } = this.state;
      const thirdList = (secondList.find((i) => i.id === val) || {}).sub || [];
      const channelSelect = this.state.channelSelect;
      const temp = thirdList.map((i) => ({ value: i.id, label: i.name })) || [];

      channelSelect[2].options = [
        { value: "allThirdLevel", label: "全部三级渠道" },
        ...temp,
      ];
      this.setState({ channelSelect, thirdList });
    }
  }

  handleChannelLinkage = async (val) => {
    let tempChannelSelect = this.state.channelSelect;

    tempChannelSelect[1].options = [
      { value: "allSecondLevel", label: "全部二级渠道" },
    ];
    tempChannelSelect[2].options = [
      { value: "allThirdLevel", label: "全部三级渠道" },
    ];
    // console.log('*****',this.state.allChannel);
    // 筛出二级渠道

    if (true) {
      await this.getSecondChanelById(val);
      const subs = store.remote.secondChannel || [];
      let tempSubChannel = {};
      let secondList = subs;

      subs.forEach((ele) => {
        tempSubChannel[ele.id] = ele.name;
        tempChannelSelect[1].options.push({
          value: ele.id,
          label: ele.name,
        });
      });
      this.setState({
        jsonSubChannel: tempSubChannel,
        channelSelect: tempChannelSelect,
        secondList,
      });
    } else {
      this.state.allChannel.forEach((item) => {
        if (val === item.id) {
          const subs = item.sub || [];
          let tempSubChannel = {};
          let secondList = subs;

          subs.forEach((ele) => {
            tempSubChannel[ele.id] = ele.name;
            tempChannelSelect[1].options.push({
              value: ele.id,
              label: ele.name,
            });
          });
          this.setState({
            jsonSubChannel: tempSubChannel,
            channelSelect: tempChannelSelect,
            secondList,
          });
        }
      });
    }
  };

  setFormData = (data, key, options, initOpt) => {
    const tempOptions = options || [];
    const tempData = data;

    tempData.forEach((item) => {
      if (item.key === key) {
        item.options = initOpt.slice();
        item.options = item.options.concat(
          tempOptions.map((item) => {
            return { value: item.id, label: item.name };
          })
        );
      }
    });

    this.setState({ channelSelect: tempData });
  };

  getAllGames = async () => {
    let jsonAllGames = {};
    let allGamesType = {};
    await getAllGames().then((res) => {
      let games = res.data.data || [];
      games.forEach((item) => {
        if (!jsonAllGames[item.gameId]) {
          jsonAllGames[item.gameId] = item.gameName || item.gameId;
          allGamesType[item.gameId] = item.gameType || "";
        }
      });
    });
    await getCombGames().then((res) => {
      let combGames = [];
      if (res.data && res.data.meta.errCode === 0)
        combGames = res.data.data || [];
      combGames.forEach((item) => {
        if (!jsonAllGames[item.gameId]) {
          jsonAllGames[item.gameId] = item.gameName || item.gameId;
          allGamesType[item.gameId] = item.gameTp || "";
        }
      });
    });
    console.log("handledGame: ", jsonAllGames, allGamesType);
    this.setState({
      jsonAllGames: jsonAllGames,
      allGamesType: allGamesType,
    });
  };

  handleModalCancel = () => {
    try {
      let tempChannel = this.state.channelSelect;
      delete tempChannel[0].defaultValue;
      tempChannel[1].defaultValue = "allSecondLevel";

      this.setState({
        visible: false,
        pagination: {
          pageSzie: 10,
          current: 1,
          total: 0,
        },
        tableDetailData: [],
        channelSelect: tempChannel,
      });
    } catch (error) {
      console.log(error);
      this.setState({
        visible: false,
        pagination: {
          pageSzie: 10,
          current: 1,
          total: 0,
        },
        tableDetailData: [],
      });
    }
  };

  componentDidMount() {
    this.getAllYears();
    this.getAllGames();
    this.getAllChannel();
  }

  // onDatePickerChange = (date) => {
  //     this.setState(
  //         {
  //             defaultValue: "",
  //             selectedVal: {
  //                 start: date.start,
  //                 end: date.end
  //             },

  //         }, () => {
  //             this.handleSearch()
  //         }
  //     );
  // };

  handleSelectChange = (value, key) => {
    const tempVal = this.state.selectedVal;
    tempVal.start = value ? new Date(value, 0, 1, 0, 0, 0).getTime() / 1000 : 0;
    tempVal.end = value
      ? new Date(value + 1, 0, 1, 0, 0, 0).getTime() / 1000
      : 0;
    this.setState({ selectedVal: tempVal }, () => {
      this.handleSearch();
    });
  };

  render() {
    let columns = [
      {
        title: "月份",
        dataIndex: "time",
        align: "center",
      },
      {
        title: "总收益",
        dataIndex: "income",
        align: "center",
        render: (text, record) => (
          <span>{Number(record.income).toFixed(2)}</span>
        ),
      },
      {
        title: "总分成收益",
        dataIndex: "rltIncome",
        align: "center",
        render: (text, record) => (
          <span>{Number(record.rltIncome).toFixed(2)}</span>
        ),
      },
      {
        title: "操作",
        align: "center",
        render: (text, record) => (
          <div>
            <Button
              type="primary"
              onClick={() => {
                this.handleChannelBreakdown(record);
              }}
            >
              收入明细
            </Button>
          </div>
        ),
      },
    ];
    /**
     * 设置用户权限
     * 20210901需求
     * https://kbcineyoxn.feishu.cn/docs/doccnotiaughCYME5uJSZIsAzVc
     */
    const {
      userInfo: { roles, firstLevelChannelIds },
      detailHideColumns,
      defaultColumns: dcolumns,
    } = this.state;

    const is2ndAdmin = roles[0] === "5c04d804789476febdaab601"; // 二级渠道用户
    const id = firstLevelChannelIds[0];
    const map = {
      "5fd70885d7af7b70fd7317cf": "外部CPCC",
      "5bf3a9b226c61a59bd7cafce": "外部CPA",
    };
    if (is2ndAdmin && map[id]) {
      columns = columns.filter(
        ({ title }) => ["总收益", "总分成收益"].indexOf(title) === -1
      );
    }
    const defaultColumns = dcolumns.filter(
      ({ dataIndex }) => detailHideColumns.indexOf(dataIndex) === -1
    );

    return (
      <div>
        <h2 style={{ marginTop: 18 }}>渠道账单</h2>

        <ul style={{ overflow: "hidden", marginTop: 28 }}>
          {this.state.allSelect.map((item) => {
            return (
              <li
                key={item.key}
                style={{
                  float: "left",
                  width: 280,
                  marginRight: 20,
                }}
              >
                <span style={{ lineHeight: "32px" }}>{item.title}</span>
                <Select
                  optionFilterProp="children"
                  allowClear={true}
                  maxTagCount={1}
                  mode={item.mode || ""}
                  placeholder={item.placeholder}
                  defaultValue={item.defaultValue}
                  onChange={(value) => {
                    this.handleSelectChange(value, item.key);
                  }}
                  style={{ width: "75%", float: "right" }}
                  showSearch
                >
                  {item.options.map((ele) => {
                    return (
                      <Option key={ele.value} value={ele.value}>
                        {ele.label}
                      </Option>
                    );
                  })}
                </Select>
              </li>
            );
          })}
        </ul>
        <Table
          locale={{ emptyText: "暂无数据" }}
          rowKey={(item) => item.time}
          style={{ marginTop: 28 }}
          columns={columns}
          pagination={false}
          dataSource={this.state.tableData}
        />
        <Modal
          width="900px"
          destroyOnClose={true}
          footer={null}
          title={`${this.state.currtenMonth} 渠道明细`}
          visible={this.state.visible}
          onCancel={this.handleModalCancel}
          okText="确认"
          cancelText="取消"
        >
          <ul style={{ overflow: "hidden" }}>
            {this.state.channelSelect.map((item) => {
              return (
                <li
                  key={item.key}
                  style={{
                    float: "left",
                    width: 200,
                    marginRight: 20,
                  }}
                >
                  <Select
                    optionFilterProp="children"
                    allowClear={true}
                    maxTagCount={1}
                    mode={item.mode || ""}
                    placeholder={item.placeholder}
                    value={item.defaultValue}
                    onChange={(value) => {
                      this.handleChannelSelectChange(value, item.key);
                    }}
                    style={{ width: "100%" }}
                    showSearch
                  >
                    {item.options.map((ele) => {
                      return (
                        <Option key={ele.value} value={ele.value}>
                          {ele.label}
                        </Option>
                      );
                    })}
                  </Select>
                </li>
              );
            })}
            <li
              style={{
                float: "left",
                marginRight: 20,
              }}
            >
              <Button type="primary" onClick={this.handleChannelSearch}>
                查询
              </Button>
            </li>
            <li
              style={{
                float: "left",
                marginRight: 20,
              }}
            >
              <Button
                type="primary"
                onClick={() => {
                  this.handleDownload();
                }}
              >
                下载
              </Button>
            </li>
          </ul>
          <Table
            locale={{ emptyText: "暂无数据" }}
            rowKey={(item) => item.index}
            style={{ marginTop: 18 }}
            scroll={{ x: "100%", y: "400px" }}
            columns={defaultColumns}
            pagination={this.state.pagination}
            onChange={(page, pageSize) => {
              this.changePage(page);
            }}
            dataSource={this.state.tableDetailData}
          />
        </Modal>
      </div>
    );
  }
}

export default ChannelBill;

